import "./site-scene.css";

/**
 * 公開の頁の場面の絵 (public/site-scenes)。絵は頁ごと分類ごとに描いた別の絵で、暗い版は色の組を替えた別の絵 (filter では暗くしない)。
 * 札は <id>-light.svg と -dark.svg (1200x630)。頭の帯は、狭い画面が 2 対 1 に切る <id>-light.svg と -dark.svg (1200x360)、
 * 広い画面が 1000 幅で 130px の低い帯 <id>-wide-light.svg と -wide-dark.svg (1200x156)。
 * 明暗の切り替えは site-scene.css が html の data-theme で行う。暗い版は lazy なので、明るい版の頁では読まれない。装飾なので alt は空
 */
const TILE = { width: 1200, height: 630 } as const;
const BAND = { width: 1200, height: 360 } as const;
const WIDE = { width: 1200, height: 156 } as const;

/** 札の頭の絵。LearnCard の art に渡す */
export function SiteSceneTile({ id }: { id: string }) {
  return (
    <>
      <img alt="" {...TILE} decoding="async" loading="lazy" src={`/site-scenes/${id}-light.svg`} className="site-scene__img--light" />
      <img alt="" {...TILE} decoding="async" loading="lazy" src={`/site-scenes/${id}-dark.svg`} className="site-scene__img--dark" />
    </>
  );
}

function BandPicture({ id, mode, eager }: { id: string; mode: "light" | "dark"; eager: boolean }) {
  return (
    <picture className={`site-scene__img--${mode}`}>
      <source media="(min-width: 640px)" srcSet={`/site-scenes/${id}-wide-${mode}.svg`} width={WIDE.width} height={WIDE.height} />
      <img alt="" {...BAND} decoding="async" loading={eager ? "eager" : "lazy"} fetchPriority={eager ? "high" : "low"} src={`/site-scenes/${id}-${mode}.svg`} />
    </picture>
  );
}

/** 頁の頭の全幅の帯。頁の頭の 1 枚なので明るい版は先に読む */
export function SiteSceneBand({ id, className = "" }: { id: string; className?: string }) {
  return (
    <div data-site-scene={id} aria-hidden="true" className={`site-scene--band ${className}`.trim()}>
      <BandPicture id={id} mode="light" eager />
      <BandPicture id={id} mode="dark" eager={false} />
    </div>
  );
}
